import { useCallback, useEffect, useState } from 'react';
import { getAtsDashboard } from '../../../services/atsDashboardService';

// Hazır dönem seçenekleri (brief: "özel tarih aralığı şart değil"). Sırayla
// AtsDashboardPage'in GenericSelect seçeneklerini üretmek için kullanılır —
// etiketler atsDashboard.filters.range.<preset> anahtarlarından gelir.
export const RANGE_PRESETS = ['last30', 'last90', 'thisYear'];

const DAY_MS = 24 * 60 * 60 * 1000;

// ISO from/to hesaplar. "thisYear" takvim yılı başlangıcını, diğerleri bugünden
// geriye N günü kullanır — backend varsayılanı (son 90 gün) ile aynı mantık.
function computeDateRange(preset) {
  const to = new Date();
  let from;
  if (preset === 'thisYear') {
    from = new Date(to.getFullYear(), 0, 1);
  } else if (preset === 'last30') {
    from = new Date(to.getTime() - 30 * DAY_MS);
  } else {
    from = new Date(to.getTime() - 90 * DAY_MS);
  }
  return { from: from.toISOString(), to: to.toISOString() };
}

// Tek uçlu pano: leave-dashboard/expense-dashboard'ın aksine kart başına ayrı
// bir fetcher YOK — /v1/ats-dashboard tek çağrıda yedi kartın tamamını
// (kpi/funnel/stageDurations/slaBreach/sources/aging/interviewHealth)
// döndürüyor (dondurulmuş sözleşme). Bu yüzden slices map'i değil tek bir
// `data` state'i var.
export const useAtsDashboardApi = () => {
  const [range, setRange] = useState('last90');
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async (activePreset) => {
    setLoading(true);
    try {
      const { from, to } = computeDateRange(activePreset);
      const res = await getAtsDashboard({ from, to });
      // api.js GET okumalarında reject ETMEZ (bkz. CLAUDE.md bilinen tuzaklar);
      // gerçek başarı sinyali res.data.status, ama biz doğrudan res.data.data'yı
      // okuyoruz — hem hata hem de gerçekten boş sonuç aynı null/undefined'a
      // düşer ve kartlar bunu "boş durum" olarak gösterir (çökme yok).
      setData(res.data?.data ?? null);
    } catch {
      setData(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    load(range);
  }, [range, load]);

  const refetchAll = useCallback(() => load(range), [load, range]);

  return {
    range,
    setRange,
    data,
    loading,
    refetchAll,
  };
};
